/*
 * @Author: your name
 * @Date: 2024-07-15 09:22:03
 * @LastEditTime: 2024-07-15 09:30:48
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \ep-admin-management\src\views\form\routers.ts
 */
import { createRouter, createWebHistory } from "vue-router"

function getRoutes() {
  const routes = [
    {
      path: '/form',
      name: 'Form',
      component: () => import(`@/views/form/index.vue`)
    },
  ]
  return routes;
}

const router = createRouter({
  history: createWebHistory(),
  routes: getRoutes()
})

export default router;
